import { defineMessages } from 'react-intl';

export default defineMessages({
  distance: {
    id: 'order_method.distance',
    defaultMessage: 'Distance',
  },
  location_rank: {
    id: 'order_method.location_rank',
    defaultMessage: 'Location rank',
  },
  location_rank_and_distance: {
    id: 'order_method.location_rank_and_distance',
    defaultMessage: 'Location rank and distance',
  },
});
